module.exports = ".footer{\r\n\tmax-height: 70px;\r\n}\r\n\r\n.footer-item {\r\n\tmargin: 5px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-general/components/footer/footer.component.css
// module id = ./src/app/ui-general/components/footer/footer.component.css
// module chunks = main